import { useCallback } from 'react';
import { cx } from '@linaria/core';
import { useFormikContext } from 'formik';
import { selectModelTypeFieldTypeInfo } from 'modules/Models/components/ModelForm/utils/utils';
import { formContainer, inputContainer } from 'modules/Models/components/ModelForm/styles';
import { FormikInitialValues } from 'modules/Models/components/ModelForm/utils/types';
import { FormLabel } from './FormLabel';
import {
  descriptionContainer,
  switchContainer,
  switchCheckbox,
  switchLabel,
  switchLabelOn,
  switchLabelOff,
  switchKnob,
} from './ToggleFormElement.styles';

type ToggleFormComponentProps = React.InputHTMLAttributes<HTMLInputElement> & { path: string };

export const ToggleFormComponent = ({ path, disabled }: ToggleFormComponentProps) => {
  const { values, setFieldValue } = useFormikContext();
  const { fieldValueMap } = values as FormikInitialValues;
  const { description = '', default_value = '' } = selectModelTypeFieldTypeInfo(path, values as FormikInitialValues);
  const inputValue: string = (fieldValueMap[path] as string) || (default_value as string);

  const onChange = useCallback(
    (e) => {
      setFieldValue('fieldValueMap', { ...fieldValueMap, [path]: e.target.checked });
    },
    [fieldValueMap, path],
  );

  return (
    <div className={formContainer}>
      <div className={inputContainer}>
        <FormLabel path={path} description={description as string} />
        <div className={descriptionContainer}>
          <label className={cx(switchContainer, inputValue && 'isChecked')}>
            <input type="checkbox" checked={!!inputValue} onChange={onChange} className={cx(switchCheckbox)} disabled={disabled} />
            {inputValue && <span className={cx(switchLabel, switchLabelOn, 'isChecked')}>ON</span>}
            {!inputValue && <span className={cx(switchLabel, switchLabelOff)}>OFF</span>}
            <span className={cx(switchKnob, inputValue && 'isChecked', !inputValue && 'isBefore')} />
          </label>
        </div>
      </div>
    </div>
  );
};
